/* PRE-BAKED uit Admin API — overschrijfbaar door Liquid-map zodra producten live zijn */
window.HELLIX_VARIANT_MAP = window.HELLIX_VARIANT_MAP || {};
Object.assign(window.HELLIX_VARIANT_MAP, {
  "HX-DH-33": {
    "variantId": "54036675232085",
    "price": 1.93,
    "title": "Hellix Dakhaak Aluminium 33-35 mm",
    "handle": "hellix-dakhaak-aluminium-33-35-mm",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-DH-33-43-product-shot.jpeg?v=1780087768"
  },
  "HX-DH-43": {
    "variantId": "54036675264853",
    "price": 1.98,
    "title": "Hellix Dakhaak Aluminium 43-45 mm",
    "handle": "hellix-dakhaak-aluminium-43-45-mm",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-DH-33-43-product-shot_c78646d7-3439-42a0-8a8b-6959514e14db.jpeg?v=1780087774"
  },
  "HX-DH-VS": {
    "variantId": "54036675297621",
    "price": 3.34,
    "title": "Hellix Dakhaak Verstelbaar",
    "handle": "hellix-dakhaak-verstelbaar",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-DH-VS-product-shot.jpeg?v=1780087779"
  },
  "HX-BV-EK": {
    "variantId": "54036675821909",
    "price": 0.36,
    "title": "Hellix Eindkap Montagerails",
    "handle": "hellix-eindkap-montagerails",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-BV-EK-product-shot.jpeg?v=1780087823"
  },
  "HX-KL-EK-30": {
    "variantId": "54036675559765",
    "price": 1.7,
    "title": "Hellix Eindklem Multi 30 mm",
    "handle": "hellix-eindklem-multi-30-mm",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-KL-EK-product-shot.png?v=1780087803"
  },
  "HX-KL-EK-30-ZW": {
    "variantId": "54036675625301",
    "price": 1.9,
    "title": "Hellix Eindklem Multi 30 mm Zwart",
    "handle": "hellix-eindklem-multi-30-mm-zwart",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-KL-EK-product-shot_44b82dfa-7479-42d3-8a59-fbfbc4b2cbd7.png?v=1780087811"
  },
  "HX-KL-EK-35-ZW": {
    "variantId": "54036675658069",
    "price": 1.9,
    "title": "Hellix Eindklem Multi 35 mm Zwart",
    "handle": "hellix-eindklem-multi-35-mm-zwart",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-KL-EK-product-shot_c596c347-0938-4a11-864f-3b766cdd3980.png?v=1780087816"
  },
  "HX-SD-FA": {
    "variantId": "54036675395925",
    "price": 1.87,
    "title": "Hellix F-Adapter Stockschroef",
    "handle": "hellix-f-adapter-stockschroef",
    "image": ""
  },
  "HX-GC-CL": {
    "variantId": "54036675461461",
    "price": 2.76,
    "title": "Hellix Golfclip",
    "handle": "hellix-golfclip",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-GC-CL-product-shot.jpeg?v=1780087793"
  },
  "HX-BV-GM-8": {
    "variantId": "54036675854677",
    "price": 0.17,
    "title": "Hellix Groefmoer M8",
    "handle": "hellix-groefmoer-m8",
    "image": ""
  },
  "HX-GC-HV": {
    "variantId": "54036675494229",
    "price": 1.09,
    "title": "Hellix Hoekverbinder Dakhaak/Golfplaat",
    "handle": "hellix-hoekverbinder-dakhaak-golfplaat",
    "image": ""
  },
  "HX-BV-HV": {
    "variantId": "54036675789141",
    "price": 1.09,
    "title": "Hellix Hoekverbinder Universeel (sleuf)",
    "handle": "hellix-hoekverbinder-universeel-sleuf",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-BV-HV-product-shot.jpeg?v=1780087821"
  },
  "HX-BV-KS": {
    "variantId": "54036675756373",
    "price": 1.67,
    "title": "Hellix Koppelstrip Aluminium",
    "handle": "hellix-koppelstrip-aluminium",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-BV-KS-product-shot.jpeg?v=1780087820"
  },
  "HX-KL-MK-28": {
    "variantId": "54036675526997",
    "price": 1.7,
    "title": "Hellix Middenklem Multi 28-35 mm",
    "handle": "hellix-middenklem-multi-28-35-mm",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-KL-MK-product-shot.jpeg?v=1780087799"
  },
  "HX-KL-MK-28-ZW": {
    "variantId": "54036675592533",
    "price": 1.9,
    "title": "Hellix Middenklem Multi 28-35 mm Zwart",
    "handle": "hellix-middenklem-multi-28-35-mm-zwart",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-KL-MK-zwart-product-shot.png?v=1780087808"
  },
  "HX-RA-475": {
    "variantId": "54036675068245",
    "price": 23.14,
    "title": "Hellix Montagerail 4,75 m",
    "handle": "hellix-montagerail-4-75-m",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-RA-product-shot.jpeg?v=1780087758"
  },
  "HX-RA-590": {
    "variantId": "54036675101013",
    "price": 28.75,
    "title": "Hellix Montagerail 5,90 m",
    "handle": "hellix-montagerail-5-90-m",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-RA-product-shot_ac11aeb9-f864-4ba2-864c-66a20375647b.jpeg?v=1780087762"
  },
  "HX-RA-590-ZW": {
    "variantId": "54036675133781",
    "price": 42.9,
    "title": "Hellix Montagerail 5,90 m Zwart",
    "handle": "hellix-montagerail-5-90-m-zwart",
    "image": ""
  },
  "HX-RA-710": {
    "variantId": "54036675166549",
    "price": 34.53,
    "title": "Hellix Montagerail 7,10 m",
    "handle": "hellix-montagerail-7-10-m",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-RA-product-shot_74fe0c5e-d156-4815-b7cd-ae93c32f069b.jpeg?v=1780087765"
  },
  "HX-BV-BT-816": {
    "variantId": "54036675887445",
    "price": 0.12,
    "title": "Hellix RVS Dakhaakbout M8x16",
    "handle": "hellix-rvs-dakhaakbout-m8x16",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-BV-BT-product-shot.png?v=1780087825"
  },
  "HX-BV-BT-820": {
    "variantId": "54036675920213",
    "price": 0.14,
    "title": "Hellix RVS Dakhaakbout M8x20",
    "handle": "hellix-rvs-dakhaakbout-m8x20",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-BV-BT-product-shot_ed6a8cb5-de3b-4708-98d8-ace3f9933cdb.png?v=1780087827"
  },
  "HX-BV-SS": {
    "variantId": "54036675952981",
    "price": 0.45,
    "title": "Hellix Smeltschroef",
    "handle": "hellix-smeltschroef",
    "image": ""
  },
  "HX-SD-BG-375": {
    "variantId": "54036675330389",
    "price": 4.55,
    "title": "Hellix Steeldeck Beugel L-375 mm (incl. EPDM)",
    "handle": "hellix-steeldeck-beugel-l-375-mm-incl-epdm",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-SD-BG-375-product-shot.jpeg?v=1780087784"
  },
  "HX-SD-SK-10200": {
    "variantId": "54036675428693",
    "price": 2.09,
    "title": "Hellix Stokschroef M10x200",
    "handle": "hellix-stokschroef-m10x200",
    "image": "https://cdn.shopify.com/s/files/1/0937/2155/9381/files/HX-SD-SK-10200-product-shot.png?v=1780087787"
  },
  "HX-SD-TV": {
    "variantId": "54036675363157",
    "price": 2.85,
    "title": "Hellix T-Montagevoet Steeldeck",
    "handle": "hellix-t-montagevoet-steeldeck",
    "image": ""
  },
  "HX-SD-RA-610": {
    "variantId": "54036675199317",
    "price": 23.23,
    "title": "Hellix Trapezoide Profiel 20 mm 6,10 m",
    "handle": "hellix-trapezoide-profiel-20-mm-6-10-m",
    "image": ""
  }
});
